import Collapse from 'aos-ui-universal/src/icons/compiled/assets/icons/actions/collapse.svg'
import Delete from 'aos-ui-universal/src/icons/compiled/assets/icons/actions/delete.svg'
import DeleteRound from 'aos-ui-universal/src/icons/compiled/assets/icons/actions/delete-round.svg'
import Expand from 'aos-ui-universal/src/icons/compiled/assets/icons/actions/expand.svg'
import AddPhoto from 'aos-ui-universal/src/icons/compiled/assets/icons/add-photo.svg'
import AddImages from 'aos-ui-universal/src/icons/compiled/assets/icons/add-pictures.svg'
import AddUser from 'aos-ui-universal/src/icons/compiled/assets/icons/add-user.svg'
import AircraftTable from 'aos-ui-universal/src/icons/compiled/assets/icons/aircraft-table.svg'
import AirportGate from 'aos-ui-universal/src/icons/compiled/assets/icons/airport-gate.svg'
import Arrow from 'aos-ui-universal/src/icons/compiled/assets/icons/arrow.svg'
import ArrowDownward from 'aos-ui-universal/src/icons/compiled/assets/icons/arrow-downward.svg'
import ArrowHead from 'aos-ui-universal/src/icons/compiled/assets/icons/arrow-head.svg'
import ArrowRightBig from 'aos-ui-universal/src/icons/compiled/assets/icons/arrow-right-big.svg'
import ArrowRightThin from 'aos-ui-universal/src/icons/compiled/assets/icons/arrow-right-thin.svg'
import ArrowUpward from 'aos-ui-universal/src/icons/compiled/assets/icons/arrow-upward.svg'
import Asset from 'aos-ui-universal/src/icons/compiled/assets/icons/asset.svg'
import Assignment from 'aos-ui-universal/src/icons/compiled/assets/icons/assignment.svg'
import Atc from 'aos-ui-universal/src/icons/compiled/assets/icons/atc.svg'
import Attachment from 'aos-ui-universal/src/icons/compiled/assets/icons/attachment.svg'
import AutomaticFeed from 'aos-ui-universal/src/icons/compiled/assets/icons/automatic-feed.svg'
import Back from 'aos-ui-universal/src/icons/compiled/assets/icons/back.svg'
import Bag from 'aos-ui-universal/src/icons/compiled/assets/icons/bag.svg'
import Billable from 'aos-ui-universal/src/icons/compiled/assets/icons/billable.svg'
import Burger from 'aos-ui-universal/src/icons/compiled/assets/icons/burger.svg'
import Camera from 'aos-ui-universal/src/icons/compiled/assets/icons/camera.svg'
import ChannelMail from 'aos-ui-universal/src/icons/compiled/assets/icons/channels/channel-mail.svg'
import ChannelNotification from 'aos-ui-universal/src/icons/compiled/assets/icons/channels/channel-notification.svg'
import ChannelPush from 'aos-ui-universal/src/icons/compiled/assets/icons/channels/channel-push.svg'
import ChannelSms from 'aos-ui-universal/src/icons/compiled/assets/icons/channels/channel-sms.svg'
import CheckCircle from 'aos-ui-universal/src/icons/compiled/assets/icons/check-circle.svg'
import CheckCircleFilled from 'aos-ui-universal/src/icons/compiled/assets/icons/check-circle-filled.svg'
import Check from 'aos-ui-universal/src/icons/compiled/assets/icons/check-white.svg'
import CheckWhite from 'aos-ui-universal/src/icons/compiled/assets/icons/check-white.svg'
import CheckboxIndeterminateDark from 'aos-ui-universal/src/icons/compiled/assets/icons/checkbox/checkbox.svg'
import CheckboxChecked from 'aos-ui-universal/src/icons/compiled/assets/icons/checkbox/checkbox-checked.svg'
import CheckboxCheckedLight from 'aos-ui-universal/src/icons/compiled/assets/icons/checkbox/checkbox-checked-light.svg'
import CheckboxDone from 'aos-ui-universal/src/icons/compiled/assets/icons/checkbox/checkbox-done.svg'
import CheckboxEmpty from 'aos-ui-universal/src/icons/compiled/assets/icons/checkbox/checkbox-empty.svg'
import CheckboxEmptyDisabled from 'aos-ui-universal/src/icons/compiled/assets/icons/checkbox/checkbox-empty-disabled.svg'
import CheckboxGreenDone from 'aos-ui-universal/src/icons/compiled/assets/icons/checkbox/checkbox-green-done.svg'
import CheckboxIndeterminate from 'aos-ui-universal/src/icons/compiled/assets/icons/checkbox/checkbox-indeterminate.svg'
import CheckboxWhite from 'aos-ui-universal/src/icons/compiled/assets/icons/checkbox/checkbox-white.svg'
import Checklist from 'aos-ui-universal/src/icons/compiled/assets/icons/checklist.svg'
import ChecklistItem from 'aos-ui-universal/src/icons/compiled/assets/icons/checklist-item.svg'
import Chevron from 'aos-ui-universal/src/icons/compiled/assets/icons/chevron.svg'
import ChevronRight from 'aos-ui-universal/src/icons/compiled/assets/icons/chevron-right.svg'
import Close from 'aos-ui-universal/src/icons/compiled/assets/icons/close.svg'
import CloseEvent from 'aos-ui-universal/src/icons/compiled/assets/icons/close-event.svg'
import Compass from 'aos-ui-universal/src/icons/compiled/assets/icons/compass.svg'
import ConditionalIndicator from 'aos-ui-universal/src/icons/compiled/assets/icons/conditional-indicator.svg'
import ConfigureNotifications from 'aos-ui-universal/src/icons/compiled/assets/icons/configure-notifications.svg'
import ContactList from 'aos-ui-universal/src/icons/compiled/assets/icons/Contacts.svg'
import Content from 'aos-ui-universal/src/icons/compiled/assets/icons/content.svg'
import Copy from 'aos-ui-universal/src/icons/compiled/assets/icons/copy.svg'
import CreateTask from 'aos-ui-universal/src/icons/compiled/assets/icons/create-task.svg'
import CurrentTime from 'aos-ui-universal/src/icons/compiled/assets/icons/current-time.svg'
import CUSSParkingMeters from 'aos-ui-universal/src/icons/compiled/assets/icons/cuss-parking-meters.svg'
import DangerousGoods from 'aos-ui-universal/src/icons/compiled/assets/icons/dangerous-goods.svg'
import Dashboard from 'aos-ui-universal/src/icons/compiled/assets/icons/dashboard.svg'
import Datapicker from 'aos-ui-universal/src/icons/compiled/assets/icons/datapicker.svg'
import Default from 'aos-ui-universal/src/icons/compiled/assets/icons/default.svg'
import Delay from 'aos-ui-universal/src/icons/compiled/assets/icons/delay.svg'
import Departures from 'aos-ui-universal/src/icons/compiled/assets/icons/departures.svg'
import Description from 'aos-ui-universal/src/icons/compiled/assets/icons/description.svg'
import DismissNotification from 'aos-ui-universal/src/icons/compiled/assets/icons/dismiss-notification.svg'
import Done from 'aos-ui-universal/src/icons/compiled/assets/icons/done.svg'
import Download from 'aos-ui-universal/src/icons/compiled/assets/icons/download.svg'
import DraggingHandle from 'aos-ui-universal/src/icons/compiled/assets/icons/dragging-handle.svg'
import Drop from 'aos-ui-universal/src/icons/compiled/assets/icons/drop.svg'
import Edit from 'aos-ui-universal/src/icons/compiled/assets/icons/edit.svg'
import Emergency from 'aos-ui-universal/src/icons/compiled/assets/icons/emergency.svg'
import Events from 'aos-ui-universal/src/icons/compiled/assets/icons/events.svg'
import ExportChecklistTemplates from 'aos-ui-universal/src/icons/compiled/assets/icons/export-checklist-templates.svg'
import FeedOutConfirmation from 'aos-ui-universal/src/icons/compiled/assets/icons/feed-out-confirmation.svg'
import Filter from 'aos-ui-universal/src/icons/compiled/assets/icons/filter.svg'
import Firefighters from 'aos-ui-universal/src/icons/compiled/assets/icons/firefighters.svg'
import FlagDay from 'aos-ui-universal/src/icons/compiled/assets/icons/flag-day.svg'
import FlightChecks from 'aos-ui-universal/src/icons/compiled/assets/icons/flight-checks.svg'
import FlightInfo from 'aos-ui-universal/src/icons/compiled/assets/icons/flight-info.svg'
import Flights from 'aos-ui-universal/src/icons/compiled/assets/icons/flights.svg'
import Fold from 'aos-ui-universal/src/icons/compiled/assets/icons/fold.svg'
import Forward from 'aos-ui-universal/src/icons/compiled/assets/icons/forward.svg'
import ForwardFat from 'aos-ui-universal/src/icons/compiled/assets/icons/forward-fat.svg'
import Fuel from 'aos-ui-universal/src/icons/compiled/assets/icons/fuel.svg'
import Fullscreen from 'aos-ui-universal/src/icons/compiled/assets/icons/FullScreen.svg'
import Gas from 'aos-ui-universal/src/icons/compiled/assets/icons/gas.svg'
import GatePark from 'aos-ui-universal/src/icons/compiled/assets/icons/gate-park.svg'
import Geolocation from 'aos-ui-universal/src/icons/compiled/assets/icons/geolocation.svg'
import Green from 'aos-ui-universal/src/icons/compiled/assets/icons/green.svg'
import Grey from 'aos-ui-universal/src/icons/compiled/assets/icons/grey.svg'
import Handling from 'aos-ui-universal/src/icons/compiled/assets/icons/handling.svg'
import HeatingWires from 'aos-ui-universal/src/icons/compiled/assets/icons/heating-wires.svg'
import Help from 'aos-ui-universal/src/icons/compiled/assets/icons/help.svg'
import Hourglass from 'aos-ui-universal/src/icons/compiled/assets/icons/hourglass.svg'
import Images from 'aos-ui-universal/src/icons/compiled/assets/icons/images-big.svg'
import InfoCircle from 'aos-ui-universal/src/icons/compiled/assets/icons/info-circle.svg'
import Invalid from 'aos-ui-universal/src/icons/compiled/assets/icons/invalid.svg'
import Invitation from 'aos-ui-universal/src/icons/compiled/assets/icons/invitation.svg'
import Layers from 'aos-ui-universal/src/icons/compiled/assets/icons/layers.svg'
import Location from 'aos-ui-universal/src/icons/compiled/assets/icons/location.svg'
import LocationUnderline from 'aos-ui-universal/src/icons/compiled/assets/icons/location-underline.svg'
import LogOut from 'aos-ui-universal/src/icons/compiled/assets/icons/log-out.svg'
import Mail from 'aos-ui-universal/src/icons/compiled/assets/icons/mail.svg'
import Map from 'aos-ui-universal/src/icons/compiled/assets/icons/map.svg'
import TrainDirection from 'aos-ui-universal/src/icons/compiled/assets/icons/map-items/train-direction.svg'
import TrainInner from 'aos-ui-universal/src/icons/compiled/assets/icons/map-items/train-inner.svg'
import TrainNoDirection from 'aos-ui-universal/src/icons/compiled/assets/icons/map-items/train-no-direction.svg'
import TrainNumber from 'aos-ui-universal/src/icons/compiled/assets/icons/map-items/train-number.svg'
import MarkReview from 'aos-ui-universal/src/icons/compiled/assets/icons/mark-review.svg'
import Message from 'aos-ui-universal/src/icons/compiled/assets/icons/message.svg'
import MessageTriangle from 'aos-ui-universal/src/icons/compiled/assets/icons/message-triangle.svg'
import Messaging from 'aos-ui-universal/src/icons/compiled/assets/icons/messaging.svg'
import More from 'aos-ui-universal/src/icons/compiled/assets/icons/more.svg'
import MoreInfo from 'aos-ui-universal/src/icons/compiled/assets/icons/more-info.svg'
import NoData from 'aos-ui-universal/src/icons/compiled/assets/icons/no-data.svg'
import NoForecast from 'aos-ui-universal/src/icons/compiled/assets/icons/no-forecast.svg'
import NoPhotos from 'aos-ui-universal/src/icons/compiled/assets/icons/no-photos.svg'
import NotAllowed from 'aos-ui-universal/src/icons/compiled/assets/icons/not-allowed.svg'
import NOTAM from 'aos-ui-universal/src/icons/compiled/assets/icons/NOTAM.svg'
import Note from 'aos-ui-universal/src/icons/compiled/assets/icons/note.svg'
import Notifications from 'aos-ui-universal/src/icons/compiled/assets/icons/notifications.svg'
import NotificationsEmpty from 'aos-ui-universal/src/icons/compiled/assets/icons/notifications-empty.svg'
import Notify from 'aos-ui-universal/src/icons/compiled/assets/icons/notify-big.svg'
import OkSmall from 'aos-ui-universal/src/icons/compiled/assets/icons/ok-small.svg'
import OpenIn from 'aos-ui-universal/src/icons/compiled/assets/icons/open-in.svg'
import OperationalForecastAirside from 'aos-ui-universal/src/icons/compiled/assets/icons/operational-forecast/operational-forecast-airside.svg'
import OperationalForecastBags from 'aos-ui-universal/src/icons/compiled/assets/icons/operational-forecast/operational-forecast-bags.svg'
import OperationalForecastNetwork from 'aos-ui-universal/src/icons/compiled/assets/icons/operational-forecast/operational-forecast-network.svg'
import OperationalForecastPassengers from 'aos-ui-universal/src/icons/compiled/assets/icons/operational-forecast/operational-forecast-passengers.svg'
import OperationalForecastTerminal from 'aos-ui-universal/src/icons/compiled/assets/icons/operational-forecast/operational-forecast-terminal.svg'
import OperationalForecastTurnaround from 'aos-ui-universal/src/icons/compiled/assets/icons/operational-forecast/operational-forecast-turnaround.svg'
import Orange from 'aos-ui-universal/src/icons/compiled/assets/icons/orange.svg'
import OtherRed from 'aos-ui-universal/src/icons/compiled/assets/icons/other-red.svg'
import OutdatedApp from 'aos-ui-universal/src/icons/compiled/assets/icons/outdated-app.svg'
import Park from 'aos-ui-universal/src/icons/compiled/assets/icons/park.svg'
import ParticipantAtAirport from 'aos-ui-universal/src/icons/compiled/assets/icons/participant-at-airport.svg'
import ParticipantComing from 'aos-ui-universal/src/icons/compiled/assets/icons/participant-coming.svg'
import ParticipantCommand from 'aos-ui-universal/src/icons/compiled/assets/icons/participant-incident-command.svg'
import ParticipantLeft from 'aos-ui-universal/src/icons/compiled/assets/icons/participant-left.svg'
import ParticipantObserving from 'aos-ui-universal/src/icons/compiled/assets/icons/participant-observe.svg'
import ParticipantPending from 'aos-ui-universal/src/icons/compiled/assets/icons/participant-pending.svg'
import ParticipantRemote from 'aos-ui-universal/src/icons/compiled/assets/icons/participant-remote.svg'
import Pause from 'aos-ui-universal/src/icons/compiled/assets/icons/pause-filled.svg'
import Pax from 'aos-ui-universal/src/icons/compiled/assets/icons/pax.svg'
import Percent from 'aos-ui-universal/src/icons/compiled/assets/icons/percent.svg'
import Phone from 'aos-ui-universal/src/icons/compiled/assets/icons/phone.svg'
import PickLocation from 'aos-ui-universal/src/icons/compiled/assets/icons/pick-location.svg'
import ParkingCarReturn from 'aos-ui-universal/src/icons/compiled/assets/icons/pictograms/parking/parking_CarReturn.svg'
import ParkingP from 'aos-ui-universal/src/icons/compiled/assets/icons/pictograms/parking/parking_P.svg'
import ParkingP1 from 'aos-ui-universal/src/icons/compiled/assets/icons/pictograms/parking/parking_P1.svg'
import ParkingP2 from 'aos-ui-universal/src/icons/compiled/assets/icons/pictograms/parking/parking_P2.svg'
import ParkingP3 from 'aos-ui-universal/src/icons/compiled/assets/icons/pictograms/parking/parking_P3.svg'
import ParkingP3Pika from 'aos-ui-universal/src/icons/compiled/assets/icons/pictograms/parking/parking_P3_Pika.svg'
import ParkingP3Premium from 'aos-ui-universal/src/icons/compiled/assets/icons/pictograms/parking/parking_P3-Premium.svg'
import ParkingP4A from 'aos-ui-universal/src/icons/compiled/assets/icons/pictograms/parking/parking_P4A.svg'
import ParkingP4B from 'aos-ui-universal/src/icons/compiled/assets/icons/pictograms/parking/parking_P4B.svg'
import ParkingP5 from 'aos-ui-universal/src/icons/compiled/assets/icons/pictograms/parking/parking_P5.svg'
import ParkingP6 from 'aos-ui-universal/src/icons/compiled/assets/icons/pictograms/parking/parking_P6.svg'
import ParkingP8 from 'aos-ui-universal/src/icons/compiled/assets/icons/pictograms/parking/parking_P8.svg'
import TravelServicesArrivalServices from 'aos-ui-universal/src/icons/compiled/assets/icons/pictograms/travelServices/travelServices_arrivalServices.svg'
import TravelServicesBaggageClaim1 from 'aos-ui-universal/src/icons/compiled/assets/icons/pictograms/travelServices/travelServices_baggageClaim1.svg'
import TravelServicesBaggageClaim2A from 'aos-ui-universal/src/icons/compiled/assets/icons/pictograms/travelServices/travelServices_baggageClaim2A.svg'
import TravelServicesBaggageClaim2B from 'aos-ui-universal/src/icons/compiled/assets/icons/pictograms/travelServices/travelServices_baggageClaim2B.svg'
import TravelServicesCheckInDesks101114 from 'aos-ui-universal/src/icons/compiled/assets/icons/pictograms/travelServices/travelServices_checkInDesks101114.svg'
import TravelServicesCheckInDesks201218 from 'aos-ui-universal/src/icons/compiled/assets/icons/pictograms/travelServices/travelServices_checkInDesks201218.svg'
import TravelServicesCheckInDesks219232 from 'aos-ui-universal/src/icons/compiled/assets/icons/pictograms/travelServices/travelServices_checkInDesks219232.svg'
import TravelServicesCheckInDesks240270 from 'aos-ui-universal/src/icons/compiled/assets/icons/pictograms/travelServices/travelServices_checkInDesks240270.svg'
import TravelServicesCheckInKiosk from 'aos-ui-universal/src/icons/compiled/assets/icons/pictograms/travelServices/travelServices_checkInKiosk.svg'
import TravelServicesCustoms from 'aos-ui-universal/src/icons/compiled/assets/icons/pictograms/travelServices/travelServices_customs.svg'
import TravelServicesPassportControl from 'aos-ui-universal/src/icons/compiled/assets/icons/pictograms/travelServices/travelServices_passportControl.svg'
import TravelServicesSecurityCheck from 'aos-ui-universal/src/icons/compiled/assets/icons/pictograms/travelServices/travelServices_securityCheck.svg'
import WalkingRouteMarker from 'aos-ui-universal/src/icons/compiled/assets/icons/pictograms/walking-route-marker.svg'
import Pictures from 'aos-ui-universal/src/icons/compiled/assets/icons/pictures.svg'
import Pin from 'aos-ui-universal/src/icons/compiled/assets/icons/pin.svg'
import Pinned from 'aos-ui-universal/src/icons/compiled/assets/icons/pinned.svg'
import Place from 'aos-ui-universal/src/icons/compiled/assets/icons/place.svg'
import ArrivalsPlaceholder from 'aos-ui-universal/src/icons/compiled/assets/icons/placeholders/arrivals-placeholder.svg'
import ChecklistPlaceholder from 'aos-ui-universal/src/icons/compiled/assets/icons/placeholders/checklist-placeholder.svg'
import CreateMessageTemplatePlaceholder from 'aos-ui-universal/src/icons/compiled/assets/icons/placeholders/create-message-template-placeholder.svg'
import CreateTaskPlaceholder from 'aos-ui-universal/src/icons/compiled/assets/icons/placeholders/create-task-placeholder.svg'
import DeparturesPlaceholder from 'aos-ui-universal/src/icons/compiled/assets/icons/placeholders/departures-placeholder.svg'
import EmptyList from 'aos-ui-universal/src/icons/compiled/assets/icons/placeholders/empty-list.svg'
import InspectorPlaceholder from 'aos-ui-universal/src/icons/compiled/assets/icons/placeholders/inspector-placeholder.svg'
import InvitePlaceholder from 'aos-ui-universal/src/icons/compiled/assets/icons/placeholders/invite-placeholder.svg'
import MessagePlaceholder from 'aos-ui-universal/src/icons/compiled/assets/icons/placeholders/message-placeholder.svg'
import MessageTemplatePlaceholder from 'aos-ui-universal/src/icons/compiled/assets/icons/placeholders/message-template-placeholder.svg'
import NoEvents from 'aos-ui-universal/src/icons/compiled/assets/icons/placeholders/no-events.svg'
import NoMessages from 'aos-ui-universal/src/icons/compiled/assets/icons/placeholders/no-messages.svg'
import NoTasks from 'aos-ui-universal/src/icons/compiled/assets/icons/placeholders/no-tasks.svg'
import PrivateInvitation from 'aos-ui-universal/src/icons/compiled/assets/icons/placeholders/private-invitation.svg'
import UnitPlaceholder from 'aos-ui-universal/src/icons/compiled/assets/icons/placeholders/unit-placeholder.svg'
import UserGroupPlaceholder from 'aos-ui-universal/src/icons/compiled/assets/icons/placeholders/user-group-placeholder.svg'
import UserOutline from 'aos-ui-universal/src/icons/compiled/assets/icons/placeholders/user-outline.svg'
import UserPlaceholder from 'aos-ui-universal/src/icons/compiled/assets/icons/placeholders/user-placeholder.svg'
import Plane from 'aos-ui-universal/src/icons/compiled/assets/icons/plane.svg'
import PlaneStanding from 'aos-ui-universal/src/icons/compiled/assets/icons/plane-standing.svg'
import Play from 'aos-ui-universal/src/icons/compiled/assets/icons/play-filled.svg'
import Plus from 'aos-ui-universal/src/icons/compiled/assets/icons/plus.svg'
import Private from 'aos-ui-universal/src/icons/compiled/assets/icons/private.svg'
import PrivateClosed from 'aos-ui-universal/src/icons/compiled/assets/icons/private-closed.svg'
import RadioChecked from 'aos-ui-universal/src/icons/compiled/assets/icons/radio-checked.svg'
import RadioCheckedDisabled from 'aos-ui-universal/src/icons/compiled/assets/icons/radio-checked-disabled.svg'
import RadioEmpty from 'aos-ui-universal/src/icons/compiled/assets/icons/radio-empty.svg'
import RadioEmptyDisabled from 'aos-ui-universal/src/icons/compiled/assets/icons/radio-empty-disabled.svg'
import Recent from 'aos-ui-universal/src/icons/compiled/assets/icons/recent.svg'
import Red from 'aos-ui-universal/src/icons/compiled/assets/icons/red.svg'
import Report from 'aos-ui-universal/src/icons/compiled/assets/icons/report.svg'
import RestoreUser from 'aos-ui-universal/src/icons/compiled/assets/icons/restore-user.svg'
import RotateLeft from 'aos-ui-universal/src/icons/compiled/assets/icons/rotate-left.svg'
import RotateRight from 'aos-ui-universal/src/icons/compiled/assets/icons/rotate-right.svg'
import Route from 'aos-ui-universal/src/icons/compiled/assets/icons/route.svg'
import Save from 'aos-ui-universal/src/icons/compiled/assets/icons/save.svg'
import AircraftStands from 'aos-ui-universal/src/icons/compiled/assets/icons/scenarios/aircraft-stands.svg'
import AirlineGroundHandling from 'aos-ui-universal/src/icons/compiled/assets/icons/scenarios/airline-ground-handling.svg'
import Arrivals from 'aos-ui-universal/src/icons/compiled/assets/icons/scenarios/arrivals.svg'
import Gate from 'aos-ui-universal/src/icons/compiled/assets/icons/scenarios/gate.svg'
import Info from 'aos-ui-universal/src/icons/compiled/assets/icons/scenarios/info.svg'
import InfoManagement from 'aos-ui-universal/src/icons/compiled/assets/icons/scenarios/info-management.svg'
import Lightning from 'aos-ui-universal/src/icons/compiled/assets/icons/scenarios/lightning.svg'
import NetworkGeneral from 'aos-ui-universal/src/icons/compiled/assets/icons/scenarios/network-general.svg'
import NetworkIt from 'aos-ui-universal/src/icons/compiled/assets/icons/scenarios/network-it.svg'
import NetworkWeather from 'aos-ui-universal/src/icons/compiled/assets/icons/scenarios/network-weather.svg'
import NetworkWorld from 'aos-ui-universal/src/icons/compiled/assets/icons/scenarios/network-world.svg'
import Roads from 'aos-ui-universal/src/icons/compiled/assets/icons/scenarios/roads.svg'
import SafetySecurity from 'aos-ui-universal/src/icons/compiled/assets/icons/scenarios/safety-security.svg'
import Snow from 'aos-ui-universal/src/icons/compiled/assets/icons/scenarios/snow.svg'
import Train from 'aos-ui-universal/src/icons/compiled/assets/icons/scenarios/train.svg'
import TurnaroundGeneralInfo from 'aos-ui-universal/src/icons/compiled/assets/icons/scenarios/turnaround-general-info.svg'
import World from 'aos-ui-universal/src/icons/compiled/assets/icons/scenarios/world.svg'
import Schedule from 'aos-ui-universal/src/icons/compiled/assets/icons/schedule.svg'
import SearchFilters from 'aos-ui-universal/src/icons/compiled/assets/icons/search-filters.svg'
import Search from 'aos-ui-universal/src/icons/compiled/assets/icons/search-white.svg'
import SearchWhite from 'aos-ui-universal/src/icons/compiled/assets/icons/search-white.svg'
import SelectItem from 'aos-ui-universal/src/icons/compiled/assets/icons/select-item.svg'
import Send from 'aos-ui-universal/src/icons/compiled/assets/icons/send.svg'
import SendAlert from 'aos-ui-universal/src/icons/compiled/assets/icons/send-alert.svg'
import Settings from 'aos-ui-universal/src/icons/compiled/assets/icons/settings.svg'
import Share from 'aos-ui-universal/src/icons/compiled/assets/icons/share.svg'
import ShiftNote from 'aos-ui-universal/src/icons/compiled/assets/icons/shift_note.svg'
import ShowLess from 'aos-ui-universal/src/icons/compiled/assets/icons/show-less.svg'
import ShowMore from 'aos-ui-universal/src/icons/compiled/assets/icons/show-more.svg'
import SNOWTAM from 'aos-ui-universal/src/icons/compiled/assets/icons/SNOWTAM.svg'
import Sorting from 'aos-ui-universal/src/icons/compiled/assets/icons/sorting.svg'
import Source from 'aos-ui-universal/src/icons/compiled/assets/icons/source.svg'
import Spinner from 'aos-ui-universal/src/icons/compiled/assets/icons/spinner.svg'
import Star from 'aos-ui-universal/src/icons/compiled/assets/icons/star.svg'
import Error from 'aos-ui-universal/src/icons/compiled/assets/icons/status/error.svg'
import Success from 'aos-ui-universal/src/icons/compiled/assets/icons/status/success.svg'
import Warning from 'aos-ui-universal/src/icons/compiled/assets/icons/status/warning.svg'
import WarningBold from 'aos-ui-universal/src/icons/compiled/assets/icons/status/warning-bold.svg'
import StatusAtAirport from 'aos-ui-universal/src/icons/compiled/assets/icons/status-at-airport.svg'
import StatusComing from 'aos-ui-universal/src/icons/compiled/assets/icons/status-coming.svg'
import StatusRemote from 'aos-ui-universal/src/icons/compiled/assets/icons/status-remote.svg'
import StatusReport from 'aos-ui-universal/src/icons/compiled/assets/icons/status-report-big.svg'
import Storage from 'aos-ui-universal/src/icons/compiled/assets/icons/storage-big.svg'
import Subscriptions from 'aos-ui-universal/src/icons/compiled/assets/icons/subscriptions.svg'
import Target from 'aos-ui-universal/src/icons/compiled/assets/icons/target.svg'
import Task from 'aos-ui-universal/src/icons/compiled/assets/icons/task.svg'
import Car from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/car.svg'
import Chemicals from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/chemicals.svg'
import Contractors from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/contractors.svg'
import EquipmentMaintenance from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/EquipmentMaintenance.svg'
import Fireman from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/fireman.svg'
import Jobs from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/jobs.svg'
import LoadReception from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/LoadReception.svg'
import TaskOther from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/Other.svg'
import Refuelling from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/Refuelling.svg'
import RegularInspection from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/RegularInsp.svg'
import Road from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/road.svg'
import TakingSamples from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/Sample.svg'
import Square from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/square.svg'
import Supervision from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/Supervision.svg'
import TaskAnimalBanishment from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-animal-banishment.svg'
import TaskAnimalConfirmation from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-animal-confirmation.svg'
import TaskAnimalKill from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-animal-kill.svg'
import TaskAnimalObservation from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-animal-observation.svg'
import TaskAnimals from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-animals.svg'
import TaskDeicing from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-deicing.svg'
import TaskHba from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-hba.svg'
import TaskInspectionAreaInspection from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-inspection-area-inspection.svg'
import TaskInspectionContractor from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-inspection-contractor.svg'
import TaskInspectionFireTruck from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-inspection-fire-truck.svg'
import TaskInspectionFod from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-inspection-fod.svg'
import TaskInspectionOther from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-inspection-other.svg'
import TaskInspectionOtherActors from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-inspection-other-actors.svg'
import TaskInspectionOtherAreas from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-inspection-other-areas.svg'
import TaskInspectionRope from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-inspection-rope.svg'
import TaskInspectionRunway from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-inspection-runway.svg'
import TaskInspectionTaxiway from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-inspection-taxiway.svg'
import TaskInspectionTerminal from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-inspection-terminal.svg'
import TaskLvp from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-lvp.svg'
import TaskLvpOutline from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-lvp-outline.svg'
import TaskMaintenance from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-maintenance.svg'
import TaskMaintenanceBrushes from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-maintenance-brushes.svg'
import TaskMaintenanceGeneral from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-maintenance-general.svg'
import TaskMaintenanceSummer from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-maintenance-summer.svg'
import TaskMaintenanceWinter from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-maintenance-winter.svg'
import TaskProcessAutomatedVehicle from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-process-automated-vehicle-task.svg'
import TaskProcessDailyMaintenance from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-process-daily-maintenance.svg'
import TaskProcessDailyTerminal from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-process-daily-terminal.svg'
import TaskProcessSeasonal from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-process-seasonal-task.svg'
import TaskRecurrence from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-recurrence.svg'
import TaskRefuelling from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-refuelling.svg'
import TaskRescueService from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-rescue-service.svg'
import TaskSafetyInspection from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-safety-inspection.svg'
import TaskTemplate from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-template.svg'
import TaskTemplateStar from 'aos-ui-universal/src/icons/compiled/assets/icons/tasks/task-template-star.svg'
import Terminal from 'aos-ui-universal/src/icons/compiled/assets/icons/terminal.svg'
import Time from 'aos-ui-universal/src/icons/compiled/assets/icons/time.svg'
import Timeline from 'aos-ui-universal/src/icons/compiled/assets/icons/timeline.svg'
import Title from 'aos-ui-universal/src/icons/compiled/assets/icons/title.svg'
import ErrorToast from 'aos-ui-universal/src/icons/compiled/assets/icons/toast/error.svg'
import InfoToast from 'aos-ui-universal/src/icons/compiled/assets/icons/toast/info.svg'
import SuccessToast from 'aos-ui-universal/src/icons/compiled/assets/icons/toast/success.svg'
import WarningToast from 'aos-ui-universal/src/icons/compiled/assets/icons/toast/warning.svg'
import Transparent from 'aos-ui-universal/src/icons/compiled/assets/icons/transparent.svg'
import Type from 'aos-ui-universal/src/icons/compiled/assets/icons/type.svg'
import Undo from 'aos-ui-universal/src/icons/compiled/assets/icons/undo.svg'
import Unfold from 'aos-ui-universal/src/icons/compiled/assets/icons/unfold.svg'
import UserThumbnail from 'aos-ui-universal/src/icons/compiled/assets/icons/user-thumbnail.svg'
import Users from 'aos-ui-universal/src/icons/compiled/assets/icons/users.svg'
import Visibility from 'aos-ui-universal/src/icons/compiled/assets/icons/visibility.svg'
import VisibilityOff from 'aos-ui-universal/src/icons/compiled/assets/icons/visibility-off.svg'
import WarnSmall from 'aos-ui-universal/src/icons/compiled/assets/icons/warn-small.svg'
import WeatherAlert from 'aos-ui-universal/src/icons/compiled/assets/icons/weather_alert.svg'
import WeatherWarning from 'aos-ui-universal/src/icons/compiled/assets/icons/weather_warning.svg'
import ChartCbProbability from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/charts/chart-cb-probability.svg'
import ChartCloudBase from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/charts/chart-cloud-base.svg'
import ChartDewPoint from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/charts/chart-dew-point.svg'
import ChartFwp from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/charts/chart-fwp.svg'
import ChartFwpYellow from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/charts/chart-fwp-yellow.svg'
import ChartLvp from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/charts/chart-lvp.svg'
import ChartRain from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/charts/chart-rain.svg'
import ChartRoadTemperature from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/charts/chart-road-temperature.svg'
import ChartSnow from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/charts/chart-snow.svg'
import ChartSnowRain from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/charts/chart-snow-rain.svg'
import ChartTemperature from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/charts/chart-temperature.svg'
import ChartTfwp from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/charts/chart-tfwp.svg'
import ChartThunderstorm from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/charts/chart-thunderstorm.svg'
import ChartTriangleDown from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/charts/chart-triangle-down.svg'
import ChartTriangleUp from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/charts/chart-triangle-up.svg'
import ChartWindDirection from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/charts/chart-wind-direction.svg'
import ChartWindGusts from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/charts/chart-wind-gusts.svg'
import ChartWindGusts12 from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/charts/chart-wind-gusts-12.svg'
import ChartWindSpeed from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/charts/chart-wind-speed.svg'
import Forecast from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/forecast.svg'
import WeatherColdRoadTemperature from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/weather-cold-road-temperature.svg'
import WeatherColdTemperature from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/weather-cold-temperature.svg'
import WeatherFreezingWx from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/weather-freezing-wx.svg'
import WeatherHeavyRain from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/weather-heavy-rain.svg'
import WeatherHeavySnow from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/weather-heavy-snow.svg'
import WeatherHotRoadTemperature from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/weather-hot-road-temperature.svg'
import WeatherHotTemperature from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/weather-hot-temperature.svg'
import WeatherLightingProbability from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/weather-lighting-probability.svg'
import WeatherLightning from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/weather-lightning.svg'
import WeatherLvp from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/weather-lvp.svg'
import WeatherLvpPlain from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/weather-lvp-plain.svg'
import WeatherNormal from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/weather-normal.svg'
import WeatherRain from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/weather-rain.svg'
import WeatherRoadTemperature from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/weather-road-temperature.svg'
import WeatherSnow from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/weather-snow.svg'
import WeatherSnowRain from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/weather-snow-rain.svg'
import WeatherStrongWind from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/weather-strong-wind.svg'
import WeatherTemperature from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/weather-temperature.svg'
import WeatherThunderstormProb from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/weather-thunderstorm-prob.svg'
import WeatherWindDirection from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/weather-wind-direction.svg'
import WeatherWindGusts from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/weather-wind-gusts.svg'
import WeatherWindSpeed from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/weather-wind-speed.svg'
import WindScale from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-items/wind-scale.svg'
import WeatherNotice from 'aos-ui-universal/src/icons/compiled/assets/icons/weather-notice.svg'
import Window from 'aos-ui-universal/src/icons/compiled/assets/icons/window.svg'
import WorldGrey from 'aos-ui-universal/src/icons/compiled/assets/icons/world-grey.svg'
import Yellow from 'aos-ui-universal/src/icons/compiled/assets/icons/yellow.svg'
import ZoomIn from 'aos-ui-universal/src/icons/compiled/assets/icons/zoom-in.svg'
import ZoomOut from 'aos-ui-universal/src/icons/compiled/assets/icons/zoom-out.svg'

export const SvgIcon = {
    TaskOther,
    Supervision,
    TakingSamples,
    EquipmentMaintenance,
    LoadReception,
    RegularInspection,
    AutomaticFeed,
    CheckCircle,
    CheckCircleFilled,
    ContactList,
    Copy,
    Edit,
    Firefighters,
    Invalid,
    Place,
    Sorting,
    Subscriptions,
    Title,
    Transparent,
    Type,
    VisibilityOff,
    InfoManagement,
    InfoCircle,
    Lightning,
    NOTAM,
    SNOWTAM,
    Filter,
    DangerousGoods,
    AddPhoto,
    Fullscreen,
    Note,
    FlagDay,
    CUSSParkingMeters,
    CheckboxDone,
    Source,
    FlightChecks,
    FlightInfo,
    HeatingWires,
    Route,
    Fuel,
    ShiftNote,
    Plus,
    Terminal,
    TaskAnimalBanishment,
    TaskAnimalConfirmation,
    TaskAnimalKill,
    TaskAnimalObservation,
    TaskAnimals,
    TaskDeicing,
    TaskHba,
    TaskInspectionAreaInspection,
    TaskInspectionContractor,
    TaskInspectionFireTruck,
    TaskInspectionFod,
    TaskInspectionOtherActors,
    TaskInspectionOtherAreas,
    TaskInspectionOther,
    TaskRefuelling,
    Refuelling,
    TaskInspectionRope,
    TaskInspectionRunway,
    TaskInspectionTaxiway,
    TaskInspectionTerminal,
    TaskLvp,
    TaskLvpOutline,
    Pax,
    TaskMaintenanceBrushes,
    TaskMaintenanceGeneral,
    TaskMaintenanceSummer,
    TaskMaintenanceWinter,
    TaskMaintenance,
    TaskRescueService,
    TaskSafetyInspection,
    Collapse,
    NotificationsEmpty,
    CheckboxIndeterminateDark,
    DeleteRound,
    Delete,
    Expand,
    Arrow,
    ArrowHead,
    ArrowDownward,
    ArrowRightBig,
    ArrowUpward,
    ArrowRightThin,
    Assignment,
    Atc,
    Back,
    Burger,
    ChannelMail,
    ChannelNotification,
    ChannelPush,
    AirportGate,
    ChannelSms,
    Check,
    CheckWhite,
    CheckboxEmpty,
    CheckboxEmptyDisabled,
    CheckboxGreenDone,
    CheckboxWhite,
    CheckboxCheckedLight,
    Checklist,
    ChevronRight,
    Chevron,
    CloseEvent,
    Close,
    NoPhotos,
    Compass,
    ConditionalIndicator,
    ConfigureNotifications,
    Content,
    CreateTask,
    CurrentTime,
    Dashboard,
    Datapicker,
    Delay,
    Departures,
    Description,
    DismissNotification,
    Done,
    DraggingHandle,
    Drop,
    AircraftTable,
    Asset,
    Bag,
    GatePark,
    Green,
    Grey,
    Handling,
    LocationUnderline,
    OkSmall,
    Orange,
    Park,
    Red,
    Undo,
    WarnSmall,
    Yellow,
    Billable,
    Camera,
    Play,
    Pause,
    Phone,
    Emergency,
    Events,
    ExportChecklistTemplates,
    FeedOutConfirmation,
    Flights,
    Fold,
    Car,
    Chemicals,
    Contractors,
    Fireman,
    Jobs,
    Road,
    Square,
    ForwardFat,
    Forward,
    Geolocation,
    InfoToast,
    SuccessToast,
    ErrorToast,
    WarningToast,
    Help,
    Hourglass,
    Images,
    Invitation,
    Layers,
    Location,
    LogOut,
    Mail,
    TrainDirection,
    TrainInner,
    TrainNoDirection,
    TrainNumber,
    Map,
    Message,
    MessageTriangle,
    Messaging,
    More,
    NoData,
    NoForecast,
    NoEvents,
    NoMessages,
    NoTasks,
    NotAllowed,
    AddImages,
    Notifications,
    Notify,
    OpenIn,
    OutdatedApp,
    OperationalForecastBags,
    OperationalForecastNetwork,
    OperationalForecastPassengers,
    OperationalForecastTurnaround,
    OperationalForecastTerminal,
    OperationalForecastAirside,
    OtherRed,
    PickLocation,
    Plane,
    PlaneStanding,
    ParkingCarReturn,
    ParkingP,
    ParkingP1,
    ParkingP2,
    ParkingP3Premium,
    ParkingP3,
    ParkingP3Pika,
    ParkingP4A,
    ParkingP4B,
    ParkingP5,
    ParkingP6,
    ParkingP8,
    ParticipantAtAirport,
    ParticipantComing,
    ParticipantCommand,
    ParticipantObserving,
    ParticipantPending,
    ParticipantLeft,
    ParticipantRemote,
    Percent,
    TravelServicesArrivalServices,
    TravelServicesBaggageClaim1,
    TravelServicesBaggageClaim2A,
    TravelServicesBaggageClaim2B,
    TravelServicesCheckInDesks101114,
    TravelServicesCheckInDesks201218,
    TravelServicesCheckInDesks219232,
    TravelServicesCheckInDesks240270,
    TravelServicesCheckInKiosk,
    TravelServicesCustoms,
    TravelServicesPassportControl,
    TravelServicesSecurityCheck,
    WalkingRouteMarker,
    Pictures,
    Pin,
    Pinned,
    ArrivalsPlaceholder,
    ChecklistPlaceholder,
    CreateMessageTemplatePlaceholder,
    CreateTaskPlaceholder,
    DeparturesPlaceholder,
    EmptyList,
    InspectorPlaceholder,
    InvitePlaceholder,
    MessagePlaceholder,
    MessageTemplatePlaceholder,
    PrivateInvitation,
    UnitPlaceholder,
    UserGroupPlaceholder,
    UserPlaceholder,
    PrivateClosed,
    Private,
    RestoreUser,
    AddUser,
    RotateLeft,
    RotateRight,
    Save,
    Schedule,
    SearchFilters,
    Search,
    SearchWhite,
    SelectItem,
    Send,
    SendAlert,
    Settings,
    Share,
    ShowLess,
    ShowMore,
    Spinner,
    Star,
    StatusReport,
    Storage,
    Error,
    Success,
    WarningBold,
    Warning,
    Target,
    Task,
    TaskRecurrence,
    Time,
    Timeline,
    Unfold,
    UserThumbnail,
    Users,
    Visibility,
    ChartCbProbability,
    ChartCloudBase,
    ChartDewPoint,
    ChartFwp,
    ChartFwpYellow,
    ChartLvp,
    ChartRain,
    ChartRoadTemperature,
    ChartSnowRain,
    ChartSnow,
    ChartTemperature,
    ChartTfwp,
    ChartThunderstorm,
    ChartTriangleDown,
    ChartTriangleUp,
    ChartWindDirection,
    ChartWindGusts12,
    ChartWindGusts,
    ChartWindSpeed,
    WeatherColdRoadTemperature,
    WeatherColdTemperature,
    WeatherFreezingWx,
    WeatherHeavyRain,
    WeatherHeavySnow,
    WeatherHotRoadTemperature,
    WeatherHotTemperature,
    WeatherLightingProbability,
    WeatherLightning,
    WeatherLvp,
    WeatherLvpPlain,
    WeatherNormal,
    WeatherRoadTemperature,
    WeatherRain,
    WeatherSnowRain,
    WeatherSnow,
    WeatherStrongWind,
    WeatherTemperature,
    WeatherThunderstormProb,
    WeatherWindDirection,
    WeatherWindGusts,
    WeatherWindSpeed,
    Forecast,
    WindScale,
    Window,
    WorldGrey,
    Default,
    ZoomIn,
    ZoomOut,
    CheckboxChecked,
    CheckboxIndeterminate,
    RadioChecked,
    RadioCheckedDisabled,
    RadioEmpty,
    RadioEmptyDisabled,
    Gas,
    MarkReview,
    StatusAtAirport,
    StatusComing,
    StatusRemote,
    MoreInfo,
    Attachment,
    Download,
    WeatherAlert,
    WeatherNotice,
    WeatherWarning,
    Recent,
    ChecklistItem,
    Report,
    TaskProcessAutomatedVehicle,
    TaskProcessDailyMaintenance,
    TaskProcessDailyTerminal,
    TaskProcessSeasonal,
    UserOutline,
    AirlineGroundHandling,
    Arrivals,
    AircraftStands,
    Gate,
    Roads,
    SafetySecurity,
    Snow,
    Train,
    TurnaroundGeneralInfo,
    Info,
    World,
    NetworkIt,
    NetworkGeneral,
    NetworkWeather,
    NetworkWorld,
    TaskTemplateStar,
    TaskTemplate,
} as const
